import { Component, OnInit } from '@angular/core';
import { DataStoreService } from 'src/app/data-store.service';
import { Player } from 'src/app/models/models';

@Component({
  selector: 'app-recruiter',
  templateUrl: './recruiter.component.html',
  styleUrls: ['./recruiter.component.scss']
})
export class RecruiterComponent implements OnInit {

  constructor(public store: DataStoreService) { }

  ngOnInit(): void {
  }

  AddPlayer(player: Player) {
    this.store.players.push(player);
    this.store.Save();
  }
  Fire(player: Player) {
    this.store.players = this.store.players.filter(x => x !== player);
    this.store.Save();
  }

  AddCrystals(player: Player) {
    var existing = this.store.inventory.find(x => x.name === 'Class Crystal' && x.tier === (player.tier + 1));
    if (existing)
      existing.quantity++;
    else
      this.store.inventory.push({ name: 'Class Crystal', tier: player.tier + 1, quantity: 1 });

    this.store.Save();
  }

  Boost(player: Player) {
    player.exp += 10000;
  }
}
